import { tvpil } from '../compat/tvpil';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchCollection } from './fetchCollection';

export function prefetchCollection({ referenceId, pageSize }: { referenceId: string; pageSize: number }) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return Promise.resolve();
  }

  const collectionId = category.channels?.[0];

  if (!collectionId) {
    return Promise.resolve();
  }

  const adultCategoryReferenceId = tvpil.transactionStore.isAdultEntitled
    ? undefined
    : tvpil.dms.adultsConfigurations?.categoryReferenceId;

  return queryClient.prefetchInfiniteQuery({
    queryKey: queryKeys.collection(referenceId, pageSize),
    queryFn: ({ pageParam }) =>
      fetchCollection({
        collectionId,
        pageSize,
        pageIndex: pageParam,
        adultCategoryReferenceId,
        groupBy: category.groupBy,
        kSql: category.aggregatedKSQL,
      }),
    initialPageParam: 1,
  });
}
